var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircleHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58214 0 0 3.58214 0 8C0 12.4179 3.58214 16 8 16C12.4179 16 16 12.4179 16 8C16 3.58214 12.4179 0 8 0ZM8 14.6429C4.33214 14.6429 1.35714 11.6679 1.35714 8C1.35714 4.33214 4.33214 1.35714 8 1.35714C11.6679 1.35714 14.6429 4.33214 14.6429 8C14.6429 11.6679 11.6679 14.6429 8 14.6429Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7032 7.76922L6.41572 3.92993C6.37331 3.89885 6.3231 3.88015 6.27069 3.87592C6.21828 3.87169 6.16573 3.8821 6.11888 3.90598C6.07204 3.92987 6.03275 3.96629 6.00539 4.01119C5.97803 4.05609 5.96368 4.10771 5.96393 4.16029V11.8389C5.96393 12.0728 6.22822 12.2049 6.41572 12.0692L11.7032 8.22993C11.7397 8.20363 11.7695 8.16903 11.79 8.12898C11.8105 8.08892 11.8212 8.04457 11.8212 7.99958C11.8212 7.95458 11.8105 7.91023 11.79 7.87018C11.7695 7.83013 11.7397 7.79552 11.7032 7.76922V7.76922ZM7.10322 10.1621V5.83708L10.08 7.99958L7.10322 10.1621V10.1621Z",
    fill: "white",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircleHeader);
export default __webpack_public_path__ + "static/media/PlayCircleHeader.99db4f10e28cd6f0724c74e7296e483c.svg";
export { ForwardRef as ReactComponent };